var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 25.223V11.061M23.885 33H9.167a5.5 5.5 0 0 1-5.5-5.5V11.06",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 20.2 5.655 14.356a3.728 3.728 0 0 1-1.99-3.297V11a3.666 3.666 0 0 1 3.667-3.667H32.94a3.727 3.727 0 0 1 3.727 3.727v.037c0 1.36-.754 2.61-1.958 3.245l-11.125 5.86a7.333 7.333 0 0 1-6.835-.003ZM35.292 30.528 31.28 34.54l-2.405-2.407",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.917 26.256c3.221 3.23 3.221 8.47.002 11.702-3.153 3.165-8.516 3.165-11.671 0-3.221-3.232-3.22-8.471.002-11.702a8.231 8.231 0 0 1 11.667 0Z",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgMail;